import React, { FunctionComponent } from 'react';
import { ReviewsFilters } from '../hooks/useReviewFilters';
import { Review } from '../types/review.type';
import {
  ModerationSection,
  ModerationSectionActions,
  ModerationSectionContent,
} from './ModerationSection';
import { ReviewActions } from './ReviewActions';
import { ReviewCheckerLabel } from './ReviewCheckerLabel';
import { ReviewContent } from './ReviewContent';
import { ReviewHeader } from './ReviewHeader';
import { ReviewLockerLabel } from './ReviewLockerLabel';
import { ReviewMetaLine } from './ReviewMetaLine';
import { ReviewSourceLabel } from './ReviewSourceLabel';
import { ReviewStatusLabel } from './ReviewStatusLabel';
import { ReviewTrustLevelBadge } from './ReviewTrustLevelBadge';
import { ReviewPresentationsLine } from './ReviewPresentationsLine';

type ReviewSectionProps = {
  review: Review;
  onReviewChange: () => void;
  onFilter: (filters: Partial<ReviewsFilters>) => void;
};

export const ReviewSection: FunctionComponent<ReviewSectionProps> = ({
  review,
  onReviewChange,
  onFilter,
}) => {
  return (
    <ModerationSection>
      <ReviewHeader
        title={review.reviewAspect}
        labels={
          <>
            <ReviewStatusLabel review={review} />
            <ReviewSourceLabel source={review.source} />
            <ReviewCheckerLabel
              review={review}
              onClick={(): void => {
                onFilter({ hasCheckerId: true });
              }}
            />
            <ReviewLockerLabel review={review} />
            {review.status === 'ok' ? (
              <ReviewTrustLevelBadge trustLevel={review.trustLevel} />
            ) : null}
          </>
        }
        meta={<ReviewMetaLine review={review} />}
      />
      <ModerationSectionContent>
        <ReviewContent review={review} />
      </ModerationSectionContent>
      <ReviewPresentationsLine
        review={review}
        onReviewChange={onReviewChange}
      />
      <ModerationSectionActions>
        <ReviewActions review={review} onReviewChange={onReviewChange} />
      </ModerationSectionActions>
    </ModerationSection>
  );
};
